import React from 'react';

const GuidelinesOnBtn = (props) => (
    <div 
    	className={`guidelines-on-btn guidelines-btn ${props.selected && 'on'}`} 
    	onClick={props.onClick}
    ></div>
);

export default GuidelinesOnBtn;


// WEBPACK FOOTER //
// ./src/components/sections/shared/GuidelinesOnBtn.js